import { createSlice } from '@reduxjs/toolkit';

import { initFailed, initSucceeded } from '../../actions/comboSummaryActions';

const labelsSlice = createSlice({
  name: 'labels',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initSucceeded, (_state, action) => action.payload.labels)
      .addCase(initFailed, (_state, action) => action.payload.labels);
  },
});

export default labelsSlice.reducer;
